import React, { createContext } from 'react';

export const LocalidadesContext = createContext();